import { Link, redirect } from "react-router";

import { BugIcon } from "lucide-react";

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

import SignUpForm from "@/features/auth/components/SignUpForm";
import { AuthLayout } from "@/pages/AuthLayout";
import { getFeatures } from "@/shared/lib/services/features";
import { getSession } from "@/shared/lib/utils/session";

export async function signUpLoader() {
  const session = getSession();

  if (session) {
    throw redirect("/");
  }

  const { signUpEnabled } = await getFeatures();

  if (!signUpEnabled) {
    throw redirect("/account/login");
  }

  return null;
}

export default function SignUp() {
  return (
    <AuthLayout>
      <div className="mb-6 text-center">
        <h1 className="font-heading text-2xl font-semibold tracking-tight">Create your account</h1>
        <p className="mt-1.5 text-sm text-muted-foreground">
          Already have an account?{" "}
          <Link to="/account/login" className="font-medium text-primary underline underline-offset-4 hover:text-primary/80 transition-colors">
            Sign in
          </Link>
        </p>
      </div>
      <Card>
        <CardHeader>
          <div className="flex items-center gap-2">
            <BugIcon className="size-4 text-primary" />
            <CardTitle>Sign up</CardTitle>
          </div>
          <CardDescription>Fill in the details below to get started with BugTracker.</CardDescription>
        </CardHeader>
        <CardContent>
          <SignUpForm />
        </CardContent>
      </Card>
    </AuthLayout>
  );
}
